import set from 'lodash/set';
import pull from 'lodash/pull';
import includes from 'lodash/includes';
import {TopLevelSectionName} from 'utils/DBUtils';

export const toggleSectionOpen = (state, {sectionGroup, sectionKey}) => {
  // All section groups except for global may only have one open section at a time
  let group = null;

  if (sectionGroup) {
    // Create group if doesn't exist
    if (!state.sectionsActiveGroups[sectionGroup]) {
      state.sectionsActiveGroups[sectionGroup] = [];
    }
    group = state.sectionsActiveGroups[sectionGroup];

    // this prevents us from nesting subsections
    // Set all other sections in group to false
    // group.map(section => section.key)
    //   .filter(key => key !== sectionKey)
    //   .forEach(key => {
    //     set(group.find(section => section.key === key), 'open', false);
    //   });
  } else {
    // Use global
    group = state.sectionsActiveGroups.global;
  }

  const section = group.find(section => section.key === sectionKey);
  if (!section) {
    // Set selected section to open
    group.push({key: sectionKey, open: true});
  } else {
    // else invert toggle
    section.open = !section.open;
  }
};

export const registerSection = (state, {sectionGroup = 'global', sectionKey}) => {
  if (!state.sectionsActiveGroups[sectionGroup]) {
    state.sectionsActiveGroups[sectionGroup] = [];
  }

  const group = state.sectionsActiveGroups[sectionGroup];
  group.push({
    key: sectionKey,
    open: false,
    fields: []
  });
};

export const unregisterSection = (state, {sectionGroup = 'global', sectionKey}) => {
  const group = state.sectionsActiveGroups[sectionGroup];
  const section = group.find(section => section.key === sectionKey);
  pull(group, section);
};



// WEBPACK FOOTER //
// ./public/utils/sectionManagement/reductions.js